import React, { useState } from "react";

const Card = ({ label, topics }) => {
  return (
    <div className="border rounded-lg shadow-md bg-gray-100">
      <div
        className={`${
          label === "Very Weak"
            ? "bg-red-500"
            : label === "Weak"
            ? "bg-orange-400"
            : label === "Average"
            ? "bg-yellow-400"
            : label === "Strong"
            ? "bg-green-500"
            : "bg-green-700"
        } text-white flex justify-between items-center py-2 px-4 rounded-t-lg`}
      >
        <p className="font-semibold">{label}</p>
        <p className="text-sm">
          {label === "Very Weak"
            ? "0%-20%"
            : label === "Weak"
            ? "21%-40%"
            : label === "Average"
            ? "41%-60%"
            : label === "Strong"
            ? "61%-80%"
            : "81%-100%"}
        </p>
      </div>
      <div className="px-4 py-2 rounded-b-lg">
        <ul className="list-disc pl-5 text-sm">
          {topics?.map((topic, idx) => (
            <li key={idx} className="mt-2">
              {topic?.category || topic}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const Summary = ({ summaryData, subWiseData }) => {
  const tabs = [
    { key: "tab1", label: "Sub Wise" },
    { key: "tab2", label: "Strategy Wise" },
  ];

  const categorizeAccuracy = (accuracy) => {
    if (accuracy >= 0 && accuracy <= 20) {
      return { range: "Very Weak" };
    } else if (accuracy >= 21 && accuracy <= 40) {
      return { range: "Weak" };
    } else if (accuracy >= 41 && accuracy <= 60) {
      return { range: "Average" };
    } else if (accuracy >= 61 && accuracy <= 80) {
      return { range: "Strong" };
    } else if (accuracy >= 81 && accuracy <= 100) {
      return { range: "Very Strong" };
    }
  };
  const categorizedData = {
    "Very Weak": [],
    Weak: [],
    Average: [],
    Strong: [],
    "Very Strong": [],
  };
  for (let category in summaryData) {
    const accuracy = summaryData[category].you.accuracy;
    const { range } = categorizeAccuracy(accuracy);
    if (range) {
      const topics = [category];
      categorizedData[range]?.push({
        category: category,
        score: summaryData[category].you,
        strengthCategory: {
          topics: topics,
        },
      });
    }
  }
  const [activeTab, setActiveTab] = useState("tab1");
  return (
    <div>
      <div className="flex flex-wrap gap-2 lg:gap-4 border-b mt-7">
        {tabs?.map((tab) => (
          <button
            key={tab?.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-3 py-1 flex justify-center font-semibold text-md items-center transition duration-300 ${
              activeTab === tab?.key
                ? "border-b-2 border-[#124699]"
                : "text-gray-700"
            }`}
          >
            {tab?.label}
          </button>
        ))}
      </div>

      <div className="mt-4">
        {activeTab === "tab1" && (
          <div className="w-full bg-white text-black p-4 rounded-md">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              {Object.keys(subWiseData)?.map((key, index) => (
                <Card
                  key={index}
                  label={key}
                  topics={
                    subWiseData[key]?.map((item) => item.subjectName) || []
                  }
                />
              ))}
            </div>
          </div>
        )}

        {activeTab === "tab2" && (
          <div className="w-full bg-white text-black p-4 rounded-md">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-5">
              {Object.keys(categorizedData)?.map((key, index) => (
                <Card
                  key={index}
                  label={key}
                  topics={categorizedData[key] || []}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Summary;
